import { render } from "./GrowthScreen.vue?vue&type=template&id=e889369a&scoped=true"
import script from "./GrowthScreen.vue?vue&type=script&lang=js"
export * from "./GrowthScreen.vue?vue&type=script&lang=js"

import "./GrowthScreen.vue?vue&type=style&index=0&id=e889369a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e889369a"]])

export default __exports__